// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartcolourdefault0": "#e3007d",
	"chartcolourdefault1": "#015193",
	"chartcolourdefault2": "#00906e",
	"chartcolourdefault3": "#249edc",
	"chartcolourdefault4": "#082d51",
	"chartcolourdefault5": "#960f5a",
	"chartcolourdefault6": "#64c5ab",
	"chartcolourdefault7": "#522882",
	"chartcolourdefault8": "#004837",
	"chartcolourdefault9": "#9c54cf",
	"chartcolourdefault10": "#e1b128",
	"chartcolourdefault11": "#d66c16",
	"chartcolourgrey": "#999",
	"chartcolourgreycartogram": "#ddd",
	"chartcolourgreylight": "#d9d9d9",
	"chartcolourdiverging0": "#5d2882",
	"chartcolourdiverging1": "#9c54cf",
	"chartcolourdiverging2": "#cba3e5",
	"chartcolourdiverging3": "#e9f8fa",
	"chartcolourdiverging4": "#52d1af",
	"chartcolourdiverging5": "#00906e",
	"chartcolourdiverging6": "#004837"
};
export default ___CSS_LOADER_EXPORT___;
